/* user modules */
angular.module('bmsApp.fees', ['ui.router'])
	.config(['$stateProvider', '$urlRouterProvider', 'BMSPermission', function config($stateProvider, $urlRouterProvider, BMSPermission) {
		$stateProvider

			.state('main.fees', {
				abstract: true
			})

			.state('main.fees.index', {
				url: '^/fees',
				views: {
					'main@main': {
						templateUrl: "ng/fees/templates/FeeIndex.html",
						controller: 'FeeIndexCtrl'
					}
				},
				ncyBreadcrumb: {label: 'Fees'}
			})

	}]);



